import { createRouter, createWebHistory } from "vue-router";
import SinglePageFlowMedia from "@/components/SinglePageFlowMedia.vue";
import PaymentForm from "../components/payment/PaymentForm.vue";
import PaymentMedia from "../components/payment/PaymentMedia.vue";
import QuestionnairePage from "../components/questionnaire/QuestionnairePage.vue";
import QuestionnaireView from "../components/questionnaire/QuestionnaireView.vue";
import QuestionnaireCompleted from "../components/questionnaire/QuestionnaireCompleted.vue";
import QuestionnaireFailed from "../components/questionnaire/QuestionnaireFailed.vue";
import NYFormPage from "../components/NYForm/NYFormPage.vue";
import NYFormView from "../components/NYForm/NYFormView.vue";
import NYFormSucceed from "../components/NYForm/NYFormSucceed.vue";
import NYFormFailed from "../components/NYForm/NYFormFailed.vue";
import PaymentSucceed from "../components/payment/PaymentSucceed.vue";
import PaymentFailed from "../components/payment/PaymentFailed.vue";
import GenericFailed from "../components/payment/GenericFailed.vue";
import PaymentStatus from "../components/payment/PaymentStatus.vue";
import PaymentPending from "../components/payment/PaymentPending.vue";
import ProviderPaidWarning from "../components/payment/ProviderPaidWarning.vue";
import OrderCancelled from "../components/payment/OrderCancelled.vue";

import BloodDrawMedia from '@/components/bloodDraw/BloodDrawMedia.vue';
import BloodDrawView from "@/components/bloodDraw/BloodDrawView.vue";

//ShippingAddressMedia is used for protect privacy, processing params in link and redirect to /informationLanding
import ShippingAddressMedia from "@/components/shippingAddress/ShippingAddressMedia.vue";
import ShippingAddressView from '../components/shippingAddress/ShippingAddressView.vue';


import CollectStatusView from '@/components/emailCollectStatus/CollectStatusView.vue';

import ConfirmAppointmentView from "@/components/confirmAppointment/ConfirmAppointmentView.vue";
import FailedConfirmAppointmentView from "@/components/confirmAppointment/FailedConfirmAppointmentView.vue";
import SuccessConfirmAppointmentView from "@/components/confirmAppointment/SuccessConfirmAppointmentView.vue";

import CancelAppointmentView from '@/components/cancelAppointment/CancelAppointmentView.vue';
import SuccessCancelAppointmentView from '@/components/cancelAppointment/SuccessCancelAppointmentView.vue';
import FailedCancelAppointmentView from '@/components/cancelAppointment/FailedCancelAppointment.vue';

import FedexPickupPage from '@/components/fedexPickup/FedexPickupPage.vue';
import FedexPickupSearchPage from '@/components/fedexPickup/FedexPickupSearchPage.vue';
import FedexSchedulesDetailsPage from '@/components/fedexPickup/FedexSchedulesDetailsPage.vue';
import CollectionPage from '@/components/collection/CollectionPage.vue';
import CollectionDetailPage from '@/components/collection/CollectionDetail.vue';
import EmptyStatePage from '@/components/payment/EmptyStatePage.vue';

// Hormone Zoomer
import HormoneZoomerView from '@/components/hormoneZoomer/HormoneZoomerView.vue';
import HormoneZoomerPage from '@/components/hormoneZoomer/HormoneZoomerPage.vue';
import HormoneZoomerFailed from '@/components/hormoneZoomer/HormoneZoomerFailed.vue';
import QuestionnaireAuth from '@/components/auth/QuestionnaireAuth.vue';
// Gut Zoomer
import GutZoomerView from '@/components/gutZoomer/GutZoomerView.vue';
import GutZoomerPage from '@/components/gutZoomer/GutZoomerPage.vue';
import GutZoomerFailed from '@/components/gutZoomer/GutZoomerFailed.vue';
// Cardio Qnr
import CardioQnrView from '@/components/cardioQnr/CardioQnrView.vue';
import CardioQnrPage from '@/components/cardioQnr/CardioQnrPage.vue';
import CardioQnrFailed from '@/components/cardioQnr/CardioQnrFailed.vue';



import HomeView from "../components/Homepage.vue"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "homeView",
      component: HomeView,
    },
    {
      path: '/payment',
      //redirect old version link to new version
      redirect: (to) => ({
        path: '/pns_single_page_flow',
        query: {
          // --------------- order info and auth params ----------------
          ...(to.query.accession_id != null && { accession_id: to.query.accession_id }),
          ...(to.query.sample_id != null && { sample_id: to.query.sample_id }),
          ...(to.query.jwtToken != null && { token: to.query.jwtToken }),
          // --------------- order info and auth params ----------------
          // --------------- flow type params ----------------
          ...(to.query.direct_to_blooddraw != null && { direct_to_blooddraw: to.query.direct_to_blooddraw }),
          ...(to.query.amount_to_pay != null && { amount_to_pay: to.query.amount_to_pay }),
          ...(to.query.payment_prioritized != null && { payment_prioritized: to.query.payment_prioritized}),
          // --------------- flow type params Ends ----------------
          // --------------- other params ----------------
          ...(to.query.count != null && { count: to.query.count}),
          // count: Number String,
          // --------------- other params Ends ----------------

        }
      })
    },
    {
      path:'/pns_single_page_flow',
      name:'singlePageFlowMedia',
      component: SinglePageFlowMedia,
    },
    {
      path: "/payment_status",
      name: "paymentStatus",
      component: PaymentStatus,
      props: (route) => ({
        bnpl: route.query.bnpl,
      }),
    },
    {
      path: "/paymentMedia",
      name: "paymentMedia",
      component: PaymentMedia,
    },
    {
      path: "/payment_form",
      name: "paymentForm",
      component: PaymentForm,
    },
    {
      path: "/payment_failed",
      name: "paymentFailed",
      component: PaymentFailed,
    },
    {
      path: "/failed",
      name: "genericFailed",
      component: GenericFailed,
    },
    {
      path: "/payment_succeed",
      name: "paymentSucceed",
      component: PaymentSucceed,
    },
    {
      path: "/payment_pending",
      name: "paymentPending",
      component: PaymentPending,
    },
    {
      // The order pending page is the page used when order is provider-paid, but the provider hasn't clear the responsible balance
      path: "/order_pending",
      name: "providerPaidWarning",
      component: ProviderPaidWarning,
    },
    {
      path: "/order_cancelled",
      name: "orderCancelled",
      component: OrderCancelled,
    },
    {
      path: "/questionnaire",
      name: "questionnairePage",
      component: QuestionnairePage,
      props: (route) => ({
        sample_id: route.query.sample_id,
        accession_id: route.query.accession_id,
        jwtToken: route.query.jwtToken,
        role: route.query.role,
      }),
    },
    {
      path: "/nyform",
      name: "nyForm",
      component: NYFormPage,
      props: (route) => ({
        sample_id: route.query.sample_id,
        accession_id: route.query.accession_id,
        jwtToken: route.query.jwttoken,
      }),
    },
    {
      path: "/ny_form",
      name: "nyFormView",
      component: NYFormView,
      // props: (route) => ({
      //   sample_id: route.query.sample_id,
      //   accession_id: route.query.accession_id,
      //   jwtToken: route.query.jwtToken,
      // }),
    },
    {
      path: "/nyform_success",
      name: "nyFormSuccess",
      component: NYFormSucceed
    },
    {
      path: "/nyform_failed",
      name: "nyFormFailed",
      component: NYFormFailed
    },
    {
      path: "/hormoneQuestionnaire",
      name: "questionnaireView",
      component: QuestionnaireView,
    },
    {
      path: "/hormoneQuestionnaire/:accession_id",
      name: "questionnaireViewWithAccession",
      component: QuestionnaireView,
      props: true, 
    },
    {
      path: "/questionnaire_completed",
      name: "questionnaireCompleted",
      component: QuestionnaireCompleted,
    },
    {
      path: "/questionnaire_failed",
      name: "questionnaireFailed",
      component: QuestionnaireFailed,
    },
    // BloodDrawMedia works as a media to process params in the link to PROCTECT privacy before redirecting to BloodDrawMedia.
    {
      path: "/bloodDraw",
      name: "bloodDrawMedia",
      component: BloodDrawMedia,
    },
    {
      path: "/bloodDrawLanding",
      name: "bloodDrawView",
      component: BloodDrawView,
    },
    // ShippingAddressMedia works as a media to process params in the link to PROCTECT privacy before redirecting to ShippingAddressView.
    {
      path: "/uploadShippingAddress",
      name: "shippingAddressMedia",
      component: ShippingAddressMedia,
    },
    {
      path: "/informationLanding",
      name: "shippingAddressView",
      component: ShippingAddressView,
    },
    {
      path: "/collectStatus",
      name: "collectStatusView",
      component: CollectStatusView,
    },
    {
      path: "/confirmAppointment",
      name: "confirmAppointment",
      component: ConfirmAppointmentView,
    },
    {
      path: "/confirmAppointment/success",
      name: "confirmAppointmentSuccess",
      component: SuccessConfirmAppointmentView,
    },
    {
      path: "/confirmAppointment/failed",
      name: "confirmAppointmentFailed",
      component: FailedConfirmAppointmentView,
    },
    {
      path: "/cancelAppointment",
      name: "cancelAppointment",
      component: CancelAppointmentView,
    },
    {
      path:'/cancelAppointment/success',
      name:'cancelAppointmentSuccess',
      component:SuccessCancelAppointmentView,
    },
    {
      path:'/cancelAppointment/failed',
      name:'cancelAppointmentFailed',
      component:FailedCancelAppointmentView,
    },
    {
      path:'/fedexPickup',
      name:'fedexPickupPage',
      component: FedexPickupPage,
    },
    {
      path:'/fedexPickup/search',
      name: 'fedexPickupSearchPage',
      component: FedexPickupSearchPage,
    },
    {
      path:'/fedexPickup/schedules',
      name: 'fedexSchedulesDetailsPage',
      component: FedexSchedulesDetailsPage,
    },
    {
      path: '/collections',
      name: "collections",
      component: CollectionPage,
      props: (route) => ({
        instructions: route.query.instructions,
        accession_id: route.query.accession_id,
        has_blood_draw: route.query.has_blood_draw === 'true',
      }),
    },
    {
      path: '/collections/:tubetype',
      name: 'collectionDetail', 
      component: CollectionDetailPage, 
      props: true, 
    },
    {
      path: '/empty-state',
      name: 'emptyState',
      component: EmptyStatePage,
    },
    {
      path: '/hormoneZoomer',
      name: 'hormoneZoomer',
      component: HormoneZoomerView,
    },
    {
      path: '/hormoneZoomer/:accession_id',
      name: 'hormoneZoomerWithAccession',
      component: HormoneZoomerView,
      props: true, 
    },
    {
      path: "/hormoneZoomerPage",
      name: "hormoneZoomerPage",
      component: HormoneZoomerPage,
      props: (route) => ({
        sample_id: route.query.sample_id,
        accession_id: route.query.accession_id,
        jwtToken: route.query.jwtToken,
        role: route.query.role,
      }),
    },
    {
      path: "/hormoneZoomerFailed",
      name: "hormoneZoomerFailed",
      component: HormoneZoomerFailed,
    },
    {
      path: '/gutZoomer',
      name: 'gutZoomer',
      component: GutZoomerView,
    },
    {
      path: '/gutZoomer/:accession_id',
      name: 'gutZoomerWithAccession',
      component: GutZoomerView,
      props: true, 
    },
    {
      path: "/gutZoomerPage",
      name: "gutZoomerPage",
      component: GutZoomerPage,
      props: (route) => ({
        sample_id: route.query.sample_id,
        accession_id: route.query.accession_id,
        jwtToken: route.query.jwtToken,
        role: route.query.role,
      }),
    },
    {
      path: "/gutZoomerFailed",
      name: "gutZoomerFailed",
      component: GutZoomerFailed,
    },
    // Cardio QNR
    {
      path: "/cardioZoomer",
      name: "cardioQnr",
      component: CardioQnrView,
    },
    {
      path: "/cardioZoomer/:accession_id",
      name: "cardioQnrWithAccession",
      component: CardioQnrView,
      props: true, 
    },
    {
      path: "/cardioZoomerPage",
      name: "cardioQnrPage",
      component: CardioQnrPage,
      props: (route) => ({
        sample_id: route.query.sample_id,
        accession_id: route.query.accession_id,
        jwtToken: route.query.jwtToken,
        role: route.query.role,
      }),
    },
    {
      path: "/cardioZoomerFailed",
      name: "cardioQnrFailed",
      component: CardioQnrFailed,
    },
    {
      path: "/auth/:questionnaire_type/:accession_id",
      name: "auth",
      component: QuestionnaireAuth,
      props: (route) => ({
        questionnaireType: route.params.questionnaire_type,
        accessionId: route.params.accession_id,
      }),
    },
    {
      path: "/auth/:questionnaire_type",
      name: "authWithoutAccession",
      component: QuestionnaireAuth,
      props: (route) => ({
        questionnaireType: route.params.questionnaire_type,
      }),
    }
  ],
});

export default router;
